export default __webpack_public_path__ + "static/media/product.981cbe35.png";